import React, { useState } from "react";

import { CURRENT_DDA_FLOOR } from "../../../constants";

/* Actions */
import Layout from "../../mockDashboard/Layout";

// Components
import MockDashboardForm from "./MockDashboardForm";
import { BannerCritical } from "../../mockDashboard/Banner";
import { Xs, Md } from "../../common";
import CurrentBalance from "../../mockDashboard/Components/CurrentBalance";
import AvailableCredit from "../../mockDashboard/Components/AvailableCredit";
import CreditScore from "../../mockDashboard/Components/CreditScore";
import LinkBankFooterV2 from "../linkBank/LinkBankFooterV2";
import LinkBankAccounts from "../linkBank/LinkBankAccounts";

const MockDashboard = () => {

  const [errorNetwork, setErrorNetwork] = useState(null);

  return (
    <Layout>
      <BannerCritical
        title="Please complete this step to unlock your TomoCredit card and start building your credit!"
        color="#BB0000"
      />
      <Xs to="md">
        <div className="flex flex-wrap">
          <CurrentBalance className="flex w-1/2  mt-4 pr-2" />
          <AvailableCredit className="flex w-1/2 mt-4" />
          <CreditScore className="w-full mt-4" />
        </div>
      </Xs>
      <Md>
        <div className="flex flex-col self-center mx-auto">
          <div
            className="flex flex-row -mx-2 mb-2"
            style={{ minHeight: "150px" }}
          >
            <CurrentBalance className="flex-auto px-2" />
            <AvailableCredit className="flex-auto px-2" />
            <CreditScore className="flex-auto px-2" />
          </div>
        </div>
      </Md>
      <div className="outerStack-mobile sm:outerStack">
        <div className="innerStack">
          <div className="stepDescriptionText">
            You are so close!
          </div>
          <div className="font-light text-sm mb-5">
            Please add another account. <br />
            <span className="font-bold">To be approved, </span>
            we require a total minimum balance of {CURRENT_DDA_FLOOR} across your
            connected accounts.
          </div>
          {errorNetwork && <div className="errorText">{errorNetwork}</div>}
          <LinkBankAccounts fromMockDashboard />
          <MockDashboardForm setErrorNetwork={setErrorNetwork} />
          <div className="mt-12">
            <LinkBankFooterV2 />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default MockDashboard;
